export default __webpack_public_path__ + "static/media/tabuleiro-desfocado.fc2b81e6.webp";